require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/react-share/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 2020
// module chunks = 2